export class MarcaModel {
    constructor(
        public idMarca: number,
        public nombre: string        
    ) { }
}